{
  "var": {
    "value": "en"
  },
  "page_Attendent_ABit": {
    "value": "A bit about me"
  },
  "page_Attendent_BasicInfo": {
    "value": "Basic Info"
  },
  "page_Attendent_ChangeModal": {
    "value": "Any profile changes must be reviewed and may take up to 3 business days before it is available to the public. You will receive an email when your changes have been approved."
  },
  "page_Attendent_ContactInfo": {
    "value": "Use our messaging service to safely and securely contact the recipient"
  },
  "page_Attendent_DateQuickSelect": {
    "value": "Date Quick Select"
  },
  "page_Attendent_DeleteModal": {
    "value": "Deleting your profile is permanent.  Your profile will be removed from the directory and you will no longer be able to access it. Are you sure you want to delete your profile?"
  },
  "page_Attendent_EmailUpdated": {
    "value": "Email Updated Successfully"
  },
  "page_Attendent_EnterYourEmail": {
    "value": "Write a brief message expressing your interest. Enter your email address and hit the Send Message button. The provider directory will send this message with your email address to the recipient."
  },
  "page_Attendent_HearAbout": {
    "value": "How did you hear about us?"
  },
  "page_Attendent_Hello": {
    "value": "Hello"
  },
  "page_Attendent_Maximum": {
    "value": "Maximum Travel Distance"
  },
  "page_Attendent_MessageSent_title": {
    "value": "Message Sent"
  },
  "page_Attendent_MessageSent_p1": {
    "value": "An email has been sent with your message.  If recipient believes they are a good match, they will get in contact using your email address."
  },
  "page_Attendent_MoreAbout": {
    "value": "More About My Work Experience"
  },
  "page_Attendent_WorkExperience": {
    "value": "Work Experience"
  },
  "page_Attendent_WorkEnvironmentPref": {
    "value": "Work Environment Preferences"
  },
  "page_Attendent_PersonalSummaryInfo": {
    "value": "Your personal summary is shown when you are found in a search"
  },
  "page_Attendent_PetHousehold": {
    "value": "Pet Household"
  },
  "page_Attendent_PreferredStartingDate": {
    "value": "Preferred Starting Date"
  },
  "page_Attendent_ProfileStatusInfo": {
    "value": "Set your profile to inactive to no longer appear in searches"
  },
  "page_Attendent_ProviderServices": {
    "value": "Provider Services"
  },
  "page_Attendent_SmokingHousehold": {
    "value": "Smoking Household"
  },
  "page_Attendent_Availability": {
    "value": "Availability"
  },
  "page_Attendent_WeeklyWorkPreference": {
    "value": "Please select all times when you would prefer to work"
  },
  "page_Attendent_ClientPreferences": {
    "value": "Client Preferences"
  },
  "page_Attendent_YearsExperience": {
    "value": "Years of Experience Providing Personal Care"
  },
  "page_AttendantAffirm_PasswordReset": {
    "value": "Please set your password on the next page."
  },
  "page_AttendantAffirm_Success": {
    "value": "Profile Updated Successfully, Thank You!"
  },
  "page_Attendant_Reaffirm_Success": {
    "value": "You have confirmed your account and will now continue to be displayed in the search results. Thank you!"
  },
  "page_Attendant_Reaffirm_Failure": {
    "value": "Something Went Wrong, Please Contact Support"
  },
  "page_HomeCO_BecomeAttendant": {
    "value": "BECOME AN ATTENDANT"
  },
  "page_HomeCO_Description": {
    "value": "Consumer Direct Care Network Colorado has partnered with the Colorado Department of Health Care Policy and Financing to develop a network for connecting employers to potential CDASS Attendants."
  },
  "page_HomeCO_Paragraph1": {
    "value": "Consumer Directed Attendant Support Services (CDASS) is an option in Colorado that empowers individuals to self-direct their services. An individual, who may be a person with a disability or elderly and chooses to participant in CDASS, is the legal employer of record. As employers, individuals hire, train, and manage attendants of their choice who best fit their unique needs."
  },
  "page_HomeCO_Paragraph2": {
    "value": "It is Consumer Direct Care Network’s mission to provide quality services to employers so they can remain in their homes and communities. We strive to provide excellent customer service and simple tools that support success in managing attendants. The Attendant Directory is a tool to help employers connect with attendants who can support them with their quality of life in their home and community."
  },
  "page_HomeCO_Paragraph3": {
    "value": "Employers searching for attendants on the directory choose if they want to interview and hire a potential attendant. This includes determining if the potential attendant’s skills and experience are a fit."
  },
  "page_HomeCO_FindAttendants": {
    "value": "Locate attendants in your area"
  },
  "page_HomeCO_FindAnAttendant": {
    "value": "FIND AN ATTENDANT"
  },
  "page_HomeCO_Requirements_Paragraph": {
    "value": "All potential attendants seeking work or current attendants seeking additional hours with other employers must register to utilize the Attendant Directory. Please note, completing the employment process with the employer’s selected Financial Management Services (FMS) provider is required."
  },
  "page_HomeCO_Requirements_p1": {
    "value": "Click "
  },
  "page_HomeCO_Requirements_p2": {
    "value": "HERE"
  },
  "page_HomeCO_Requirements_p3": {
    "value": " for requirements to join."
  },
  "page_HomeCO_Title": {
    "value": "CDASS Attendant Directory"
  },
  "page_HomeCO_Trademark": {
    "value": "© 2022 CDASS Attendant Directory is a registered trademark of Consumer Direct Care Network Management Solutions, Inc."
  },
  "page_Home_Title": {
    "value": "Consumer Direct Care Network (CDCN) Provider Directory"
  },
  "page_Home_p1": {
    "value": "Welcome to the Consumer Direct Care Network (CDCN) Provider Directory. This free tool connects CDCN service recipients with job seekers looking for a career in the caregiving field."
  },
  "page_Home_p2": {
    "value": "Job Seekers"
  },
  "page_Home_p3": {
    "value": "Interested in a career in the caregiving field? Register with us. You will create an online profile that highlights your experience, qualities, and interests.  After completing your profile, individuals seeking care can contact you about caregiving opportunities."
  },
  "page_Home_p4": {
    "value": "Service Recipients"
  },
  "page_Home_p5": {
    "value": "Use this directory to help you find a caregiver in your area. Please note that CDCN does not screen any profiles on the Provider Directory. CDCN does not assume any responsibility for the accuracy or reliability of information provided by caregivers."
  },
  "page_Home_p6": {
    "value": "To learn more about CDCN and our services, please visit "
  },
  "page_Home_p7": {
    "value": "ConsumerDirectCare.com."
  },
  "page_Home_FindCaregivers": {
    "value": "Locate caregivers in your area"
  },
  "page_Home_FindACaregiver": {
    "value": "FIND A CAREGIVER"
  },
  "page_Home_BecomeCaregiver": {
    "value": "BECOME A CAREGIVER"
  },
  "page_Home_DisclaimerL1": {
    "value": "The Provider Directory helps people find caregivers. Consumer Direct Care Network does not:"
  },
  "page_Home_DisclaimerL2": {
    "value": "Check or approve caregiver profiles."
  },
  "page_Home_DisclaimerL3": {
    "value": "Vet whether the caregiver can provide care."
  },
  "page_Home_DisclaimerL4": {
    "value": "Caregivers cannot provide service right away. They must be hired and approved to work first."
  },
  "page_Home_GetConnected": {
    "value": "Get connected as a caregiver"
  },
  "page_Home_GetConnectedCO": {
    "value": "Get connected as an attendant"
  },
  "page_Home_Hero_Title": {
    "value": "MAKING HOME-CARE CONNECTIONS"
  },
  "page_Home_JoinOurNetwork": {
    "value": "Join our Network"
  },
  "link_SkipToMainContent": {
    "value": "Skip to main content"
  },
  "page_Home_Radius": {
    "value": "Radius"
  },
  "page_Home_SearchInfo": {
    "value": "Enter the zipcode where you would like to receive care and then choose the distance around the zipcode you would like to find propective care providers.  Click the search button to find all applicable providers."
  },
  "page_Home_SearchInfoCO": {
    "value": "Enter the zipcode where you would like to receive care and then choose the distance around the zipcode you would like to find propective attendants.  Click the search button to find all applicable attendants."
  },
  "page_Home_Terms_title": {
    "value": "Terms and Conditions of Use"
  },
  "page_Home_Terms_view": {
    "value": "View Full Terms and Conditions"
  },
  "page_Home_Terms": {
    "value": "Provider Directory is not responsible for the content of any messages sent between potential providers and clients.  Provider Directory monitors profile contents but not message content."
  },
  "page_Home_Trademark": {
    "value": "© Consumer Direct Care Network (CDCN) Provider Directory is a registered trademark of Consumer Direct Management Solutions, Inc."
  },
  "page_Home_Requirements_Paragraph": {
    "value": "Make a difference in your community."
  },
  "page_Home_TC_1": {
    "value": "Last Updated: 1/6/2026"
  },
  "page_Home_TC_2": {
    "value": "Welcome to Provider Directory (“the Site”), an online provider directory operated by Consumer Direct Care Network (“we,” “our,” or “us”). By accessing or using this Site, you agree to these Terms and Conditions (“Terms”). If you do not agree, please discontinue use immediately."
  },
  "page_Home_TC_3": {
    "value": "1. Purpose of the Site"
  },
  "page_Home_TC_4": {
    "value": "This Site serves as a directory of healthcare and related service providers. It is intended solely for informational purposes to help users identify and connect with providers. The Site does not provide medical advice, diagnoses, or treatment. You should always consult a qualified healthcare professional for medical concerns."
  },
  "page_Home_TC_5": {
    "value": "2. Use of the Site"
  },
  "page_Home_TC_6": {
    "value": "You may use this Site only for lawful purposes, including viewing provider listings and submitting legitimate requests for information. You agree not to use the Site for unauthorized data mining, spamming, or any activity that disrupts Site operations or compromises user privacy."
  },
  "page_Home_TC_7": {
    "value": "3. Submission of Personal and Health Information"
  },
  "page_Home_TC_8": {
    "value": "When you submit a request through our portal, you may be asked to provide personally identifiable information (PII) and, in some cases, limited protected health information (PHI),  such as information about your healthcare needs or preferences. By submitting this information, you consent to its collection, use, and disclosure as described below and in our Privacy Policy."
  },
  "page_Home_TC_9": {
    "value": "You agree that:"
  },
  "page_Home_TC_10": {
    "value": "The information you provide is true, accurate, and complete."
  },
  "page_Home_TC_11": {
    "value": "Your submitted information may be securely transmitted to selected providers to facilitate contact and coordination of services."
  },
  "page_Home_TC_12": {
    "value": "You are responsible for avoiding submission of more medical details than necessary to initiate contact."
  },
  "page_Home_TC_13": {
    "value": "4. HIPAA and Data Privacy Compliance"
  },
  "page_Home_TC_14": {
    "value": "We are committed to safeguarding your privacy in compliance with the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and applicable state privacy laws."
  },
  "page_Home_TC_15": {
    "value": "We implement administrative, technical, and physical safeguards to protect PII and PHI from unauthorized access or disclosure."
  },
  "page_Home_TC_16": {
    "value": "Information submitted through the Site is encrypted in transit and stored securely."
  },
  "page_Home_TC_17": {
    "value": "Access to PII/PHI is restricted to authorized personnel who require the data to perform their job duties."
  },
  "page_Home_TC_18": {
    "value": "When information is shared with providers, it is done only for the purpose of facilitating treatment, coordination of care, or communication initiated by you."
  },
  "page_Home_TC_19": {
    "value": "Once your information is transmitted to a provider, that provider becomes responsible for safeguarding it under their own HIPAA obligations."
  },
  "page_Home_TC_20": {
    "value": "5. Provider Information Accuracy"
  },
  "page_Home_TC_21": {
    "value": "Provider listings and related information are maintained to the best of our ability. However, providers are responsible for keeping their information current. We cannot guarantee the completeness or accuracy of directory entries and are not liable for errors or outdated information."
  },
  "page_Home_TC_22": {
    "value": "6. No Medical Relationship"
  },
  "page_Home_TC_23": {
    "value": "Submitting information through the Site does not establish a medical, patient-provider, or employer relationship with Consumer Direct Care Network. We do not control the practices, services, or decisions of listed providers."
  },
  "page_Home_TC_24": {
    "value": "7. Intellectual Property"
  },
  "page_Home_TC_25": {
    "value": "All Site content, including provider listings, design elements, and text, is owned by or licensed to Consumer Direct Care Network and protected by intellectual property laws. You may not reproduce or distribute Site content without written permission."
  },
  "page_Home_TC_26": {
    "value": "8. Disclaimer of Warranties"
  },
  "page_Home_TC_27": {
    "value": "The Site and all content are provided “as is” without warranty of any kind, express or implied. Consumer Direct Care Network does not guarantee provider availability, performance, or service quality."
  },
  "page_Home_TC_28": {
    "value": "9. Limitation of Liability"
  },
  "page_Home_TC_29": {
    "value": "To the fullest extent permitted by law, Consumer Direct Care Network is not liable for any indirect, incidental, or consequential damages resulting from use of the Site, reliance on its content, or any interaction with listed providers."
  },
  "page_Home_TC_30": {
    "value": "10. Updates to Terms"
  },
  "page_Home_TC_31": {
    "value": "We may modify these Terms from time to time. Any updates will be posted on this page with a new “Last Updated” date. Continued use of the Site constitutes your acceptance of the revised Terms."
  },
  "page_Home_TC_32": {
    "value": "11. Contact Information"
  },
  "page_Home_TC_33": {
    "value": "For privacy or compliance inquiries, please contact:"
  },
  "page_Home_TC_34": {
    "value": "Privacy Officer: Holly Stephens"
  },
  "page_Home_TC_35": {
    "value": "Email: "
  },
  "page_Register_Hero_Title": {
    "value": "Become a Caregiver"
  },
  "page_Register_Hero_TitleCO": {
    "value": "Become an Attendant"
  },
  "page_Register_Hero_Join": {
    "value": "JOIN OUR NETWORK"
  },
  "page_Register_Title": {
    "value": "Interested in a career in the caregiving field?"
  },
  "page_Register_steps": {
    "value": "Simply create an online profile that highlights your experience, qualities, and interests. After completing your profile, individuals seeking care can contact you about caregiving opportunities."
  },
  "page_Register_Title_CO": {
    "value": "Join the Attendant Directory"
  },
  "page_Register_EasyStepsTitle_CO": {
    "value": "Easy Steps to get Started"
  },
  "page_Register_EasySteps_p1_CO": {
    "value": "Read and Agree to the Terms and Conditions"
  },
  "page_Register_EasySteps_p2_CO": {
    "value": "Fill out the Registration Form and click CREATE"
  },
  "page_Register_EasySteps_p3_CO": {
    "value": "Complete your Directory Profile"
  },
  "page_Register_EasySteps_p4_CO": {
    "value": "Start connecting with potential clients seeking care in your area"
  },
  "page_Register_EasySteps_p5_CO": {
    "value": "Once you have completed your profile, potential clients can review your information and message you if you're a match for their needs!"
  },
  "page_Register_AlreadySignedIn": {
    "value": "You are already signed in.  You must sign out before registering for a new account."
  },
  "page_Requirements_CDASS_title": {
    "value": "Consumer Direct Attendant Support Services (CDASS)"
  },
  "page_Requirements_CDASS_p1": {
    "value": "CDASS is a Medicaid service option under the Home and Community Based Services Program. CDASS empowers employers to direct their own care needs rather than going through a traditional home health agency. Individuals who choose to participate in CDASS are the legal employer of record for the attendants they choose to hire."
  },
  "page_Requirements_CDASS_p2": {
    "value": "Under CDASS, the employer is responsible for training, supervising and scheduling attendants at their own discretion to meet their needs. The employer is able to set the wages for attendants within their monthly budget and decide where and when they receive services. A FMS provider of the employer’s choice will assist with taxes, payroll, paperwork, background checks and screening for the attendants the employer chooses to hire."
  },
  "page_Requirements_CDASS_p3": {
    "value": "To access CDASS services and find out if you qualify, please"
  },
  "page_Requirements_CDASS_p4": {
    "value": "contact the Single Entry Point agency in your area."
  },
  "page_Requirements_CDASS_p5": {
    "value": "For more information on CDASS click on the logos below"
  },
  "page_Requirements_Employed_title": {
    "value": "Being Employed as an Attendant Caregiver Under CDASS"
  },
  "page_Requirements_Employed_p1": {
    "value": "In the CDASS program, there are certain criteria potential attendants must meet in order to be hired, which include"
  },
  "page_Requirements_Employed_p2": {
    "value": "Passing the Criminal Background and Board of Nursing checks"
  },
  "page_Requirements_Employed_p3": {
    "value": "Passing an Office of Inspector General (OIG) check"
  },
  "page_Requirements_Employed_p4": {
    "value": "Authorization to work in the United States (I-9 Form)"
  },
  "page_Requirements_Employed_p5": {
    "value": "The employer’s selected FMS provider will provide all necessary employment paperwork and facilitate completion of all criteria."
  },
  "page_Requirements_Employed_p6": {
    "value": "Please note"
  },
  "page_Requirements_Employed_p7": {
    "value": "Attendants shall not be approved or utilized for employment if ever convicted of the following crimes within any time frame"
  },
  "page_Requirements_Employed_p8": {
    "value": "Abduction"
  },
  "page_Requirements_Employed_p9": {
    "value": "Any violent felony crime (including but not limited to rape, sexual assault, homicide, felonious physical assault or felonious battery)"
  },
  "page_Requirements_Employed_p10": {
    "value": "Child/adult abuse or neglect"
  },
  "page_Requirements_Employed_p11": {
    "value": "Crimes that involve the exploitation of a child or an incapacitated adult"
  },
  "page_Requirements_Employed_p12": {
    "value": "Felony involving an act of domestic violence"
  },
  "page_Requirements_Employed_p13": {
    "value": "Felony arson"
  },
  "page_Requirements_Employed_p14": {
    "value": "Felony or misdemeanor crime against a child or incapacitated adult that causes harm"
  },
  "page_Requirements_Employed_p15": {
    "value": "Felony theft"
  },
  "page_Requirements_Employed_p16": {
    "value": "Hate crimes"
  },
  "page_Requirements_Employed_p17": {
    "value": "Fraud (including but not limited to identity theft, forgery, financial fraud, or healthcare fraud)"
  },
  "page_Requirements_Employed_p18": {
    "value": "Kidnapping"
  },
  "page_Requirements_Employed_p19": {
    "value": "Murder/homicide"
  },
  "page_Requirements_Employed_p20": {
    "value": "Neglect or abuse by a caregiver"
  },
  "page_Requirements_Employed_p21": {
    "value": "Pornography crimes involving children or incapacitated adults, including, but not limited to, use of minors in filming sexual explicit conduct, distribution and exhibition of material depicting minors in sexually explicit conduct or sending, distributing, exhibiting, possessing, displaying or transporting material by a parent, guardian or custodian, depicting a child engaged in sexually explicit conduct"
  },
  "page_Requirements_Employed_p22": {
    "value": "Purchase or sale of a child"
  },
  "page_Requirements_Employed_p23": {
    "value": "Sexual offenses (including but not limited to incest, sexual abuse, or indecent exposure)"
  },
  "page_Requirements_Employed_p24": {
    "value": "Attendants shall not be approved or utilized for employment if convicted of the following crimes within the specified time frames"
  },
  "page_Requirements_Employed_p25": {
    "value": "Felony drug related offenses (within the last 5 years)"
  },
  "page_Requirements_Employed_p26": {
    "value": "Felony DUI (within the last 5 years)"
  },
  "page_Requirements_Employed_p27": {
    "value": "To learn more about CDASS and the requirements for Attendants please contact"
  },
  "page_Requirements_Employed_p28": {
    "value": "CONSUMER DIRECT CARE NETWORK COLORADO"
  },
  "page_Requirements_Employed_p29": {
    "value": "7951 East Maplewood Avenue"
  },
  "page_Requirements_Employed_p30": {
    "value": "Suite 125"
  },
  "page_Requirements_Employed_p31": {
    "value": "Greenwood Village, CO 80111"
  },
  "page_Search_FilterBy": {
    "value": "Filters"
  },
  "title_Account": {
    "value": "Account"
  },
  "title_Accounts": {
    "value": "Accounts"
  },
  "title_Active": {
    "value": "Active"
  },
  "title_Admin": {
    "value": "Admin"
  },
  "title_Agree": {
    "value": "Agree"
  },
  "title_Any": {
    "value": "Any"
  },
  "title_Attendants": {
    "value": "Attendants"
  },
  "title_Back": {
    "value": "Back"
  },
  "title_Cancel": {
    "value": "Cancel"
  },
  "title_Certifications": {
    "value": "Certifications"
  },
  "title_ChangePassword": {
    "value": "Reset Password"
  },
  "title_ChangeEmail": {
    "value": "Change E-Mail"
  },
  "title_City": {
    "value": "City"
  },
  "title_ClearFilters": {
    "value": "Clear"
  },
  "title_Complete": {
    "value": "Complete"
  },
  "title_Confirm": {
    "value": "Confirm"
  },
  "title_Contact": {
    "value": "Contact"
  },
  "title_ContactCaregiver": {
    "value": "Contact this Caregiver"
  },
  "title_Continue": {
    "value": "Continue"
  },
  "title_DateOfBirth": {
    "value": "Date of Birth"
  },
  "title_DayAvailable": {
    "value": "Day Available"
  },
  "title_Delete": {
    "value": "Delete"
  },
  "title_DeleteProfile": {
    "value": "Delete Profile"
  },
  "title_Distance": {
    "value": "Distance (mi)"
  },
  "title_DistanceTravel": {
    "value": "Max Distance of Daily Travel"
  },
  "title_Edit": {
    "value": "Edit Profile"
  },
  "title_Email": {
    "value": "Email"
  },
  "title_YourEmail": {
    "value": "Your Email"
  },
  "title_Employment": {
    "value": "Employment"
  },
  "title_Experience": {
    "value": "Experience"
  },
  "title_False": {
    "value": "False"
  },
  "title_Fax": {
    "value": "Fax"
  },
  "title_FirstName": {
    "value": "First Name"
  },
  "title_Home": {
    "value": "Home"
  },
  "title_HoursPerWeek": {
    "value": "hr/wk"
  },
  "title_Language": {
    "value": "Español"
  },
  "title_Languages": {
    "value": "Languages"
  },
  "title_LastInitial": {
    "value": "Last Initial"
  },
  "title_Menu": {
    "value": "Menu"
  },
  "title_Message": {
    "value": "Message"
  },
  "title_Miles": {
    "value": "Miles"
  },
  "title_More": {
    "value": "Advanced Search"
  },
  "title_NoResults": {
    "value": "No Attendants Found"
  },
  "title_PageHelp": {
    "value": "Help"
  },
  "title_Pets": {
    "value": "Pets"
  },
  "title_PersonalSummary": {
    "value": "Personal Summary"
  },
  "title_Phone": {
    "value": "Phone"
  },
  "title_PleaseSelectAll": {
    "value": "Please select all that apply"
  },
  "title_PreferredLanguages": {
    "value": "Preferred Languages"
  },
  "title_Profile": {
    "value": "Profile"
  },
  "title_ProfilePicture": {
    "value": "Profile Picture"
  },
  "title_ProfileStatus": {
    "value": "Profile Status"
  },
  "title_Providers": {
    "value": "Providers"
  },
  "title_Register": {
    "value": "Register"
  },
  "title_Resume": {
    "value": "Resume"
  },
  "title_RESUME": {
    "value": "RESUME"
  },
  "title_Save": {
    "value": "Save"
  },
  "title_SaveChanges": {
    "value": "Save Changes"
  },
  "title_Search": {
    "value": "Search"
  },
  "title_Security": {
    "value": "Security"
  },
  "title_Select": {
    "value": "Select"
  },
  "title_SENDMESSAGE": {
    "value": "SEND MESSAGE"
  },
  "title_SendMessage": {
    "value": "Send Message"
  },
  "title_ServicesProvided": {
    "value": "Services Provided"
  },
  "title_SignIn": {
    "value": "Sign In"
  },
  "title_SignOut": {
    "value": "Sign Out"
  },
  "title_SignUp": {
    "value": "Sign Up"
  },
  "title_Smoking": {
    "value": "Smoking"
  },
  "title_Spam": {
    "value": "Spam"
  },
  "title_State": {
    "value": "State"
  },
  "title_Status": {
    "value": "Status"
  },
  "title_TotalWeeklyHours": {
    "value": "Total Weekly Hours"
  },
  "title_TotalWeeklyWork": {
    "value": "Total Weekly Work"
  },
  "title_TravelLimit": {
    "value": "Travel Limit"
  },
  "title_True": {
    "value": "Verdadero"
  },
  "title_WARNING": {
    "value": "WARNING"
  },
  "title_WeeklyHours": {
    "value": "Weekly Hours"
  },
  "title_Years": {
    "value": "Years"
  },
  "title_Zipcode": {
    "value": "Zipcode"
  },
  "card_view": {
    "value": "VIEW PROFILE"
  },
  "card_schedule": {
    "value": "Work Schedule"
  },
  "card_rate": {
    "value": "hrs/week"
  },
  "Certified Nursing Assistant": {
    "value": "Certified Nursing Assistant"
  },
  "CPR": {
    "value": "CPR"
  },
  "Licensed Practical Nurse": {
    "value": "Licensed Practical Nurse"
  },
  "Medical Assistant": {
    "value": "Medical Assistant"
  },
  "Nutrition": {
    "value": "Nutrition"
  },
  "Occupational Therapy": {
    "value": "Occupational Therapy"
  },
  "Qualified Medication Administration Personnel": {
    "value": "Qualified Medication Administration Personnel"
  },
  "Registered Nurse": {
    "value": "Registered Nurse"
  },
  "Hygiene & Infection Control": {
    "value": "Hygiene and Infection Control"
  },
  "Meal Preparation": {
    "value": "Meal Preparation"
  },
  "Physical Therapy": {
    "value": "Physical Therapy"
  },
  "Emergency & First Aid": {
    "value": "Emergency and First Aid"
  },
  "Bladder and Bowel Care": {
    "value": "Bladder and Bowel Care"
  },
  "Exercise/ROM": {
    "value": "Excercise/Range of Motion"
  },
  "Health Maintenance": {
    "value": "Health Maintenance"
  },
  "Medication Administration": {
    "value": "Medication Administration"
  },
  "Nail & Skin Care": {
    "value": "Nail and Skin Care"
  },
  "Respiratory Care": {
    "value": "Respiratory Care"
  },
  "Transfers & Use of lifts": {
    "value": "Transfers & Use of lifts"
  },
  "Wound Care": {
    "value": "Wound Care"
  },
  "Homemaking/Cleaning": {
    "value": "Homemaking/Cleaning"
  },
  "Personal Care Services": {
    "value": "Personal Care Services"
  },
  "Shopping": {
    "value": "Shopping"
  },
  "Current CDASS Attendant": {
    "value": "Current CDASS Attendant"
  },
  "Have Lifting Restrictions": {
    "value": "Have Lifting Restrictions"
  },
  "Non-Smoker": {
    "value": "Non-Smoker"
  },
  "Pets/Service Animals OK": {
    "value": "Pets/Service Animals OK"
  },
  "Willing to learn": {
    "value": "Willing to learn"
  },
  "English": {
    "value": "English"
  },
  "Spanish": {
    "value": "Spanish"
  },
  "Child": {
    "value": "Child"
  },
  "Legal Representative": {
    "value": "Legal Representative"
  },
  "No Relationship": {
    "value": "No Relationship"
  },
  "Other": {
    "value": "Other"
  },
  "Paid Guardian Conservator": {
    "value": "Paid Guardian Conservator"
  },
  "Parent": {
    "value": "Parent"
  },
  "Sibling": {
    "value": "Sibling"
  },
  "Spouse": {
    "value": "Spouse"
  },
  "Unpaid Guardian Conservator": {
    "value": "Unpaid Guardian Conservator"
  },
  "Today": {
    "value": "Today"
  },
  "One Week": {
    "value": "One Week"
  },
  "Two Weeks": {
    "value": "Two Weeks"
  },
  "actions_okay": {
    "value": "OK"
  },
  "footer_tagline": {
    "value": "EVERY LIFE. EVERY MOMENT. EVERY DAY."
  },
  "footer_disclaimer_title": {
    "value": "The Provider Directory helps people find caregivers. Consumer Direct Care Network does not:"
  },
  "footer_disclaimer_list1": {
    "value": "screen any profiles on the Provider Directory"
  },
  "footer_disclaimer_list2": {
    "value": "assume any responsibility for the accuracy or reliability of information provided by caregivers."
  },
  "breadcrumb_CreateProfile": {
    "value": "Create Profile"
  },
  "breadcrumb_EditProfile": {
    "value": "Edit Profile"
  },
  "breadcrumb_Home": {
    "value": "Home"
  },
  "breadcrumb_AttendantProfile": {
    "value": "Profile"
  },
  "breadcrumb_SearchResults": {
    "value": "Results"
  },
  "pager_itemsPerPage": {
    "value": "items per page"
  },
  "pager_items": {
    "value": "items"
  }
}
